import { LogoImg } from "../assests";

const Header = () => (
  <div>
    {" "}
    <a href="/">
      <LogoImg />
    </a>
  </div>
);

export default Header;
